import React, { Component } from 'react';

import {Card} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import * as EmailValidator from 'email-validator';

import Theme from '../Theme';

class Details extends Component {

  constructor(props) {
    super(props);

    this.keyTyped = this.keyTyped.bind(this);
    this.nextDisabled = this.nextDisabled.bind(this);
    this.tryNext = this.tryNext.bind(this);
  }

  nextDisabled() {
    let ret = !this.props.details.name ||
            !this.props.details.email ||
            !this.props.details.phone;
    return ret;
  }

  tryNext() {
    if (!EmailValidator.validate(this.props.details.email)) {
      // invalid email address
      this.props.updateField('emailError', 'Please enter a valid email address');
    } else if (!this.props.details.phone.replace(/[\s]/g, '').match(/^[0-9]{10}$/)) {
      this.props.updateField('phoneError', 'Please enter a valid mobile number');
    } else {
      // everything valid, move onto next step
      this.props.next();
    }
  }

  keyTyped(field, value) {
    this.props.setHasError(field, false);
    this.props.updateField(field, value);
  }

  render() {
    const styles = {
      card: {
        padding: 30,
        paddingTop: 40,
        textAlign: 'center',
        borderRadius: 12
      },
      title: {
        textAlign: 'center',
        margin: 0,
        color: Theme.palette.primary1Color,
        marginBottom: 20
      },
      button: {
        width: 80,
        marginTop: 20
      },
      wrapper: {
        width: '80%',
        maxWidth: 390,
        margin: 'auto',
        marginTop: 10
      },
      field: {
        padding: 0,
        margin: 0,
        marginTop: -15,
        width: '100%'
      },
      inputStyle: {
        width: '100%',
        textAlign: 'center',
        justifyContent: 'center'
      },
      hintStyle: {
        width: '100%',
        color: '#ccc',
        textAlign: 'center',
        justifyContent: 'center'
      },
      paragraph: {
        margin: 10,
        marginBottom: 20
      },
      dialogButton: {
        margin: 2
      }
    };
    const actions = [
      <RaisedButton
        style={styles.dialogButton}
        label="OK"
        primary={true}
        keyboardFocused={true}
        onTouchTap={() => this.handleDialogClose(true)}
      />,
      <RaisedButton
        style={styles.dialogButton}
        label="Cancel"
        onTouchTap={() => this.handleDialogClose(false)}
      />
    ];

    return (
      <div>
        <Card style={styles.card}>
          <h2 style={styles.title}>Welcome</h2>
          
          <div style={styles.paragraph}>
            Welcome to the mobile, waterless carwash service for Maserati McCarroll's.
          </div>
          <div style={styles.wrapper}>
            <TextField
              style={styles.field}
              hintStyle={styles.hintStyle}
              hintText={'Full Name'}
              floatingLabelText={this.props.details.name ? 'Full Name' : ' '}
              floatingLabelFixed={true}
              inputStyle={styles.inputStyle}
              value={this.props.details.name}
              onChange={(evt) => this.keyTyped('name', evt.target.value)}
              errorText={this.props.details.nameError ? 'Please fill in this field' : ''}
              maxLength={64}
            />
            <TextField
              style={styles.field}
              hintStyle={styles.hintStyle}
              inputStyle={styles.inputStyle}
              hintText={'Email Address'}
              floatingLabelText={this.props.details.email ? 'Email Address' : ' '}
              floatingLabelFixed={true}
              value={this.props.details.email}
              onChange={(evt) => this.keyTyped('email', evt.target.value)}
              errorText={this.props.details.emailError ? this.props.details.emailError : ''}
              maxLength={64}
            />
            <TextField
              style={styles.field}
              hintStyle={styles.hintStyle}
              inputStyle={styles.inputStyle}
              hintText={'Mobile Number'}
              floatingLabelText={this.props.details.phone ? 'Mobile Number' : ' '}
              floatingLabelFixed={true}
              value={this.props.details.phone}
              onChange={(evt) => this.keyTyped('phone', evt.target.value.replace(/[^0-9\s]/g, ''))}
              errorText={this.props.details.phoneError ? this.props.details.phoneError : ''}
              maxLength={20}
            />
          </div>
          
          <RaisedButton style={styles.button} disabled={this.nextDisabled()}
            label="Next" primary={true} onClick={this.tryNext} />
        </Card>
      </div>
    );
  }
}

export default Details;



// WEBPACK FOOTER //
// ./src/components/Details.js